import * as React from 'react';
import { useTheme } from '../../../theme';
import { useIsMobile } from '../../../utils';

interface Props {
	title?: string;
	error?: string;
	headerButton?: React.ReactNode;
}

const SectionWrapper: React.FC<Props> = ({ title, error, headerButton, children }) => {
	const { SectionWrapper: css } = useTheme('TravellerForm');

	const isMobile = useIsMobile();
	const showHeaderButton = headerButton && isMobile;
	const showTitleWrapper = !!title || showHeaderButton;
	const hasChildren = React.Children.toArray(children).length > 0;

	return (
		<div className={css.sectionWrapper}>
			{showTitleWrapper && (
				<div className={css.sectionWrapper__title_wrapper}>
					{!!title && (
						<div>
							<div className={css.sectionWrapper__title}>{title}</div>
							{!!error && <div className={css.sectionWrapper__error}>{error}</div>}
						</div>
					)}
					{showHeaderButton && headerButton}
				</div>
			)}

			{hasChildren && isMobile && showTitleWrapper && <div className={css.line} />}

			{hasChildren && <div className={css.sectionWrapper__content}>{children}</div>}
		</div>
	);
};

export default SectionWrapper;
